<template>
  <div class="collapse">
    <div
      class="collapse__header cursor-pointer transition-color duration-300"
      :class="[{ 'bg-gray-100': hover }]"
      @click="expanded = !expanded"
      @mouseenter="hover = true"
      @mouseleave="hover = false"
    >
      <div class="row m-0 items-center relative z-10">
        <div class="col-1/x">
          <div class="collapse__title">
            <slot name="header">
              {{ title }}
            </slot>
          </div>
        </div>
        <div class="col-auto" :class="{ 'pr-4': wide }">
          <i
            class="collapse__icon inline-block w-3 h-auto text-black btn-round-icon-outline"
            style="border: 0;"
          >
            <component
              :is="expanded ? 'IconLess' : 'IconPlus'"
              class="text-black"
            />
          </i>
        </div>
      </div>
    </div>

    <transition name="expanded" duration="500">
      <div
        class="collapse__content relative z-1"
        :class="[{ 'collapse__content--expanded': expanded }]"
        v-show="expanded"
      >
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script>
/** Icons */
import IconPlus from '@/assets/icons/icon-plus.svg'
import IconLess from '@/assets/icons/icon-less.svg'

export default {
  components: {
    IconPlus,
    IconLess,
  },

  props: {
    title: {
      type: String,
      default: '',
    },

    opened: {
      type: Boolean,
      default: false,
    },

    wide: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      expanded: this.opened,
      hover: false,
    }
  },

  methods: {
    show() {
      this.expanded = true
    },
    hide() {
      this.expanded = false
    },
  },
}
</script>

<style lang="scss" scoped>
.collapse {
  @include e(content) {
    @apply opacity-0 h-auto max-h-0;
    transition: max-height 500ms ease-out;

    @include m(expanded) {
      @apply opacity-100 max-h-collapse;
    }
  }
}
</style>
